:host {
  display: block;
  display: flex;
  flex-direction: column;
  height: 100%;
}
dnn-rm-files-pane{
  flex-grow: 1;
}
